module.exports = __webpack_public_path__ + "static/media/service-furniture-mobile.f7422f28.png";